import axios from 'axios';
import { API } from 'widget/helpers/axios';

const BASE_URL = process.env.VUE_APP_HIVER_CHANNELS_MIDDLEWARE_V2 + '/v2/widget';

class Hiver {
  getAvailableAgents(websiteInboxToken) {
    return axios.get(`${BASE_URL}/${websiteInboxToken}/inbox_members`);
  }
  getHiverConfig(websiteToken) {
    return axios.get(`${BASE_URL}/${websiteToken}/config`);
  }
  toggleStatus(websiteToken) {
    return API.get(
      `/api/v1/widget/conversations/toggle_status?website_token=${websiteToken}`
    );
  }
  submitContactForm(data) {
    return API.post(`${BASE_URL}/${data.token}/send_contact_email`, {
      name: data.name,
      email: data.email,
      message: data.message,
      origin: data.widgetLocationUrl
    });
  }

  registerChatbotsConversationType(
    conversationId,
    inboxId,
    triggerType,
    nudgeId
  ) {
    return API.post(
      `${BASE_URL}/inbox/${inboxId}/trigger_bot`,
      {
        conversation_display_id: conversationId,
        trigger_type: triggerType,
        nudge_id: nudgeId
      },
      {
        withCredentials: true
      }
    );
  }

  restartChatbotFlow(conversationId, inboxId) {
    return API.post(
      `${BASE_URL}/inbox/${inboxId}/restart_bot`,
      { conversation_display_id: conversationId },
      { withCredentials: true }
    );
  }

  notifyScriptLoaded(websiteToken) {
    const url = `${BASE_URL}/${websiteToken}/script_loaded`;
    return axios.patch(url);
  }
}

export default new Hiver();
